import {handleUnauthorizedMiddleware, selectAccessToken} from '@modifi/plugin-authentication'
import {clientConfig} from '@modifi/client-config'

import {rawClientFactory, ShipmentsApiClient} from './factory'

export default (): ShipmentsApiClient =>
  rawClientFactory({
    getAccessToken: () => selectAccessToken() as string,
    host: clientConfig.get('SERVICE_SHIPMENTS_API') as string,
    additionalMiddleware: [handleUnauthorizedMiddleware],
  })
